export default class ProfileController {

  constructor(app) {
    this.app = app;
    this.pageId = "Profile";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    model = app;

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  deleteAll() {
    const app = this.app;

    //this.userdata = {id:this.userdata.id};
    app.userdata = {
      name: null,
      email: null,
      avatar: null,
      coins: 0
    };
    app.save(app.userdata, true).then(function () {
      //window.location.reload();//is opening in devices browser
      //window.open("index.html", "_self");
      app.navigate("Login");
    });

  }
  applyPromoCode(code) {
    const pageId = this.pageId;
    const app = this.app;

    if (!code) return;
    let message = app.items.applyPromoCode(code, app.userdata);

    app.createNotification(message);
    app.save(app.userdata, true);
    app.populate(pageId, app);
  }
  submitProfile() {
    const app = this.app;
    const userdata = app.userdata;

    let txtName = document.getElementById("txtName");
    if (txtName) {
      userdata.name = txtName.value;
    }
    let txtEmail = document.getElementById("txtEmail");
    if (txtEmail) {
      userdata.email = txtEmail.value;
    }
    let cbDebug = document.getElementById("cbDebug");
    if (cbDebug) {
      app.debug = cbDebug.checked;
    }
    let cbBlockChat = document.getElementById("cbBlockChat");
    if (cbBlockChat) {
      userdata.isChatMuted = cbBlockChat.checked;
    }
    let cbIsMuted = document.getElementById("cbIsMuted");
    if (cbIsMuted) {
      userdata.isMuted = cbIsMuted.checked;
    }
    let cbCanvas = document.getElementById("cbCanvas");
    if (cbCanvas) {
      userdata.useCanvas = cbCanvas.checked;
    }
    let rdLanguageChecked = document.querySelector('input[name="rdLanguage"]:checked');
    if (rdLanguageChecked) {
      userdata.language = rdLanguageChecked.value;
      app.resource = app.localization.getResource(userdata.language);

    }
    let txtServerUrl = document.getElementById("txtServerUrl");
    if (txtServerUrl) {
      userdata.serverUrl = txtServerUrl.value;
    }
    app.save(userdata, true);
  }
}
